import { gql, useMutation } from '@apollo/client';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { AlertsModalType, useAlertsModalContext, useProjectAlertsContext } from '../context';

const AlertFields = `
    id
    status
    campaignType
    messageMedium
    metricName
    comparisonOperator
    threshold
    frequency
`;

const upsertAlertMutation = gql`
  mutation UpsertProjectCampaignAlertsRequest($alerts: [UpsertProjectCampaignAlertInput!]!, $applyBulkUpdates: Boolean) {
    upsertProjectCampaignAlerts(alerts: $alerts, applyBulkUpdates: $applyBulkUpdates) {
      Email {
        ${AlertFields}
      }
      Push {
        ${AlertFields}
      }
      SMS {
        ${AlertFields}
      }
      InApp {
        ${AlertFields}
      }
      WebPush {
        ${AlertFields}
      }
      Embedded {
        ${AlertFields}
      }
    }
  }
`;

type UseProjectCampaignAlertsResponse = {
  updateAlerts: any;
  isLoading: boolean;
};

export const useUpsertProjectCampaignAlertsMutation = (): UseProjectCampaignAlertsResponse => {
  const dispatch = useDispatch();
  const { closeModal } = useAlertsModalContext();
  const { setSavedAlerts } = useProjectAlertsContext();

  const [updateAlerts, { loading }] = useMutation(upsertAlertMutation, {
    onCompleted: (response) => {
      dispatch(addPositiveToast(`Project campaign alert settings updated successfully.`));
      setSavedAlerts(response?.upsertProjectCampaignAlerts);
      closeModal(AlertsModalType.UpdateAlertsModal);
    },
    onError: (e: unknown) => {
      const errorMessage = `Oops! Something’s not right. Try modifying your selection and saving again.`;
      dispatch(
        addNegativeToastWithErrorId(errorMessage, 'useUpsertProjectCampaignAlertsMutation', e),
      );
    },
  });

  return {
    updateAlerts,
    isLoading: loading,
  };
};
